var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLoginString(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 60,
    viewBox: "0 0 360 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.9272C15.2961 43.709 54.8289 65.2697 90.5921 57.2581C135.296 47.2435 198.355 1 244.836 1C291.316 1 337.5 57.2581 360 57.2581",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLoginString);
export default __webpack_public_path__ + "static/media/mobile-login-string.3e1e71b3b8104aa9da9ba4c9faa81982.svg";
export { ForwardRef as ReactComponent };